import { render } from "./SubscriptionData.vue?vue&type=template&id=34626d90&scoped=true"
import script from "./SubscriptionData.vue?vue&type=script&lang=js"
export * from "./SubscriptionData.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-34626d90"

export default script